import { useTranslation } from "react-i18next";

/**
 * Asks whether the current dictionary actually defines a key.
 *
 * The copy is not frozen: entries get removed as the product changes state, and each page is
 * pre-rendered into static HTML — so a section that assumes a key exists does not fail
 * loudly, it bakes an empty card or a dangling heading into a file that then sits on a CDN.
 *
 * Every list-driven section therefore filters through this rather than hardcoding its own
 * items, and every standalone optional line checks before it renders. A dropped key removes
 * the thing it belonged to and nothing else.
 *
 * `fallbackLng` is off (see i18n/config.ts), so `exists` answers about this locale only and
 * cannot be fooled by an English string standing in for a removed translation.
 */
export function useHasKey(): (key: string) => boolean {
  const { i18n } = useTranslation();
  return (key: string) => i18n.exists(key);
}
